import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaTimes } from "react-icons/fa";
// import useTabStore from "../../localStore/useTabStore";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment";
import { toast } from "react-toastify";
import usePermission from "../../customHook/usePermission";
import { ArrowsLeftRight, Crown2, Grown, UserSubscription } from "../../assets/img/imgIndex";

const Subscription = () => {
  const blockTab = 1;
  const arr = [
    { id: 1, name: "Subscriptions", icon: Crown2 },
    { id: 2, name: "Transaction", icon: ArrowsLeftRight },
    { id: 3, name: "User Subscription", icon: UserSubscription },
  ];

  const location = useLocation();

  const [tab, setTab] = useState(1);
  const tabRef = useRef(1);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(location?.state?.page || 1);
  const [totalCount, setTotalCount] = useState();
  const [pagination, setPagination] = useState(null);
  const [searchText, setSearchText] = useState("");
  const pageRef = useRef(page);
  const preSearchPageRef = useRef(page);

  const permission = usePermission();

  const handleSelect = (i) => {
    setTab(i.id);
    tabRef.current = i?.id;
    setData([]);
    // set("blockTab", i?.id);
  };

  const navigate = useNavigate();

  const handleView = (i) => {
    navigate("/subscription-view", {
      state: {
        item: i,
        id: i?.id,
        page: page,
        type: 'view'
      },
    });
  };

  console.log("tabRef", tabRef.current);

  const handleUnblock = async (id) => {


    let res = await put(`${URLS.SUBSCRIPTIONSTATUS}${id}/`);
    if (res?.status == "success") {
      toast.success(res?.message);
      fetchData();
    }
  };

  const fetchData = async () => {
    let url = "";
    if (tabRef.current === 1) {
      url = `${URLS.SUBSCRIPTIONLIST}?page=${page}&search=${searchText || ""}`;

    } else if (tabRef.current === 2) {
      url = `${URLS.TRANSACCTION_LIST}?page=${page}&search=${searchText || ""}`;

    } else if (tabRef.current === 3) {
      url = `${URLS.SUBSCRIPTIONUSER}?page=${page}&search=${searchText || ""}`;
    }
    if (!searchText) {
      url += `&page=${page || 1}`;
    }
    let res = await get(url);

    console.log("res subs", res);

    if (res?.status == "success") {
      setData(res?.data);
      setTotalCount(res?.count || 0);
      setPagination({
        current_page: res?.current_page || 1,
        last_page: res?.total_pages || 1,
      });
    }
  };

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    if (location?.state?.page) {
      // clear state after using it
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [page, searchText, tab]);

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return <span className="sno">{row.index + 1}</span>;
        },
      },
      {
        Header: "Subscription Name",
        accessor: "name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Type",
        accessor: "type",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value === 1 ? 'Normal' : 'FSSAI' || "N/A"}</p>;
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },

    ];

    let status = {
      Header: "Status",
      accessor: "status",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        const status = row?.original?.status;

        return (
          <button
            className="action-btn-unblock d-flex ac-jc"
            onClick={() => handleUnblock(row?.original?.id)}
          >
            {status === 1 ? (
              <span className="text-success">Active</span>
            ) : (
              <span className="text-danger">Deactive</span>
            )}
          </button>
        );
      },

    };

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-BLOCKED_SELLER") && (
              <button
                className="action-btn d-flex ac-jc"
                onClick={() => handleView(row?.original)}
              >
                <FaEye />
              </button>
            )}
          </>
        );
      },
    };

    return [...d, status, action];
  }, [page]);

  const columnsTwo = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return <span className="sno">{row.index + 1}</span>;
        },
      },
      {
        Header: "User Name",
        accessor: "user_name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Subscription Name",
        accessor: "subscription_name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Transaction ID",
        accessor: "transaction_id",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Date & Time",
        accessor: "date_time",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
    ];



    return [...d];
  }, [page]);

  const columnsThree = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return <span className="sno">{row.index + 1}</span>;
        },
      },
      // {
      //   Header: "User ID",
      //   accessor: "id",
      //   width: "70%",
      //   Cell: ({ value }) => {
      //     return <p className="mb-0">{value || "N/A"}</p>;
      //   },
      // },
      {
        Header: "User Name",
        accessor: "user_name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Subscription Name",
        accessor: "subscription_name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Type",
        accessor: "type",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Start Date",
        accessor: "created_at",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Expiry Date",
        accessor: "expiry_date",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
    ];



    return [...d];
  }, [page]);

  const handleClearSearch = () => {
    setSearchText("");
    setPage(preSearchPageRef.current || 1);
  };

  const tabIsOne = tab === 1 ? "+ Create Subscription" : null;

  return (
    <div>
      <PageHeader
        title="Subscriptions"
        buttonText={tabIsOne}
        buttonPath="/subscription-view"
        permissionAllowed={"CAN-ADD-ADMIN_LIST"}
      />
      <div className="d-flex gap-5 mb-5">
        {arr.map((i) => {
          return (
            <button
              onClick={() => handleSelect(i)}
              className={
                tab == i.id ? "header-action-btn" : "header-action-white-btn"
              }
              key={i.id}
            >
              <img
                src={i?.icon}
                style={{
                  width: 20,
                  height: 20,
                  filter: tab == i.id ? 'invert(1)' : 'invert(0)',
                }}
              />

              {i.name}
            </button>
          );
        })}
      </div>

      <div className="header-row">
        <h2 className="total-count">Total: {totalCount || 0}</h2>

        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              const val = e.target.value;

              if (!searchText && val) {
                preSearchPageRef.current = page || 1;
                setPage(1);
              } else if (searchText && !val) {
                setPage(preSearchPageRef.current || 1);
              }

              setSearchText(val);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>

      <CommonTable
        columns={tab == 1 ? columns : tab == 2 ? columnsTwo : columnsThree}
        data={data || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
    </div>
  );
};

export default Subscription;
